import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Bonjour, Je m'appelle <span className="purple">Alexis Clerc </span>
            <br />
            Actuellement, étudiant en 2ème année d'Informatique à Ynov Campus d'Aix-en-Provence.
            <br />
            Je suis passionné par les intelligences artificielles et le développement web.
            <br />
            <br />
            À part le code, il y a aussi des choses que j'aime faire comme :
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Jeux vidéos
            </li>
            <li className="about-activity">
              <ImPointRight /> Lecture
            </li>
            { <li className="about-activity">
              <ImPointRight /> Sports
            </li> }
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
